<router-outlet></router-outlet>
<p-toast [position]="isRtl() ? 'bottom-left' : 'bottom-right'" />
